
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.53 8.034A.533.533 0 010 7.496c0-.295.235-.53.53-.53h6.432V.538a.533.533 0 111.069 0v6.428h6.431a.533.533 0 110 1.068H8.031v6.428a.533.533 0 11-1.069 0V8.034H.53z","fill":"#fff"}})])
          )
        }
      }
    